module.exports = "/virtual-football-league/img/amblems/left/logos/Watford.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Watford.png
// module id = 2131
// module chunks = 4